import 'core-js/stable';
import 'regenerator-runtime/runtime';

/* 引入你需要的vant组件 */
import {
    Cell,
    CellGroup,
    Tab,
    Tabs,
    ConfigProvider,
    Icon,
    Field,
    NavBar,
    Popup,
    Image as VanImage,
    BackTop,
    Slider,
    TextEllipsis,
    Picker,
    DatePicker
} from 'vant'
/* 引入组件样式 */
import 'vant/lib/index.css';
import '@/assets/variables.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
const app = createApp(App)

/* 使用vue-router路由 */
import router from './router';
import StackKeepAlive from 'stack-keep-alive';
app.use(router).use(StackKeepAlive);
/* 使用pinia状态管理器 */
import pinia from '@/stores/index.js';
app.use(pinia);
app.use(createPinia())

app.use(Cell);
app.use(CellGroup);
app.use(Tab);
app.use(Tabs);
app.use(ConfigProvider);
app.use(Icon);
app.use(Field);
app.use(VanImage);
app.use(BackTop);
app.use(NavBar);
app.use(Popup);
app.use(Slider);
app.use(TextEllipsis);
app.use(Picker);
app.use(DatePicker);

app.mount('#app')
